<template>
  <div class="layout-col">
    <div class="top-bar">
      <div style="display: flex; align-items: center">
        <div class="logo-w">
          <router-link to="/dashboard" class="logo">
            <div class="log-img">
              <img :src="require('../assets/' + app.logo_sub)" alt />
            </div>
            <div class="logo-label" style="color: #030303">VTS Portal</div>
          </router-link>
        </div>
        <div
          class="dealer-name"
          v-if="user.dealer_name"
          style="margin-right: 60px"
        >
          <svg
            height="12"
            id="triangle-right"
            viewBox="0 0 32 32"
            width="12"
            xmlns="http://www.w3.org/2000/svg"
            fill="#3e4b5b"
          >
            <path d="M8 4 V28 L26 16 z" />
          </svg>
          <span>{{ user.dealer_name }}</span>
        </div>
        <div class="top-search">
          <el-select
            v-model="selectQueryResult"
            filterable
            remote
            reserve-keyword
            :placeholder="placeholder"
            value-key="id"
            :remote-method="search"
            :loading="searchLoading"
            @change="selectedQueryResult"
            v-if="
              hasAuth('customerList') ||
              hasAuth('orderList') ||
              hasAuth('quotationList')
            "
          >
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
            <el-option-group
              v-for="group in searchResults"
              :key="group.label"
              :label="group.label"
            >
              <el-option
                v-for="item in group.options"
                :key="item.id"
                :label="item.title"
                :value="item"
              >
                <p class="flex-row-between">
                  <span>{{ item.title }}</span>
                  <span>{{ item.subtitle }}</span>
                </p>
              </el-option>
            </el-option-group>
          </el-select>
        </div>
      </div>

      <div class="top-menu-controls">
        <div
          :class="{ over: messageHover }"
          class="messages-notifications os-dropdown-trigger os-dropdown-position-left"
          @mouseenter="
            messageHover = true
            requestUnreadMessages()
          "
          @mouseleave="messageHover = false"
        >
          <i
            class="os-icon os-icon-bell"
            style="font-size: 20px; position: relative; top: -2px"
          ></i>
          <div
            class="new-messages-count"
            style="padding-top: 2px; top: 1px"
            v-show="unreadMessageCount > 0"
          >
            {{ unreadMessageCount }}
          </div>
          <div class="os-dropdown light message-list">
            <ul v-if="unreadMessageCount > 0">
              <li v-for="(msg, index) in messages" @click="readMessage(index)">
                <router-link :to="msg.link" class="flex-row-between">
                  <div>{{ msg.content }}</div>
                  <div>{{ timePast(msg.created_at) }}</div>
                </router-link>
              </li>
            </ul>
            <div v-else class="text-info-12">暂无未读消息</div>
            <div class="message-more">
              <router-link to="/dashboard/messages">查看所有消息</router-link>
            </div>
          </div>
        </div>
        <div class="logged-user-w">
          <div class="logged-user-i">
            <div class="logged-user-info">
              <span class="text-white mr-10">{{ user.name }}</span>
              <div class="avatar-w" style="width: 30px; height: 30px">
                <auth-img v-if="user.avatar" :src="user.avatar" />
                <img v-else src="../assets/avatar.jpeg" />
              </div>
            </div>
            <div class="logged-user-menu color-style-bright">
              <div class="logged-user-avatar-info">
                <div class="avatar-w">
                  <auth-img v-if="user.avatar" :src="user.avatar" />
                  <img v-else src="../assets/avatar.jpeg" />
                </div>
                <div class="logged-user-info-w">
                  <div class="logged-user-name">{{ user.name }}</div>
                  <div class="logged-user-role">{{ user.phone_number }}</div>
                </div>
              </div>
              <div class="bg-icon">
                <i class="os-icon os-icon-wallet-loaded"></i>
              </div>
              <ul>
                <li>
                  <a href="javascript:;" @click="userSetDialogVisible = true">
                    <i class="os-icon os-icon-user"></i>
                    <span>个人设置</span>
                  </a>
                </li>
                <li>
                  <a href="javascript:;" @click="logout">
                    <i class="os-icon os-icon-signs-11"></i>
                    <span>退出</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="layout-w">
      <div class="menu-mobile menu-activated-on-click color-scheme-dark">
        <div class="mm-logo-buttons-w">
          <!-- <el-button
            style="
              color: #fff;
              font-weight: 400;
              font-size: 20px;
              line-height: 1;
              padding:0;
            "
            type="text"
            @click="goback"
            icon="el-icon-arrow-left"
          ></el-button> -->
          <router-link to="/dashboard" class="mm-logo">
            <img :src="require('../assets/' + app.logo_sub)" alt />
            <span>
              {{ user.dealer_name ? user.dealer_name : 'VTS Portal' }}
            </span>
          </router-link>
          <div class="mm-buttons" @click="switchMobileMenu">
            <div class="content-panel-open">
              <div class="os-icon os-icon-grid-circles"></div>
            </div>
            <div class="mobile-menu-trigger">
              <div class="os-icon os-icon-hamburger-menu-1"></div>
            </div>
          </div>
        </div>
        <div class="menu-and-user" v-show="mobileMenu">
          <!-- <el-menu
            class="el-menu-vertical"
            text-color="#fff"
            active-text-color="#047bf8"
            :router="true"
            :unique-opened="true"
            :default-active="$route.name"
          >
            <template v-for="group in menuGroups">
              <template
                v-for="(item, index) in group.children.filter(
                  (item) => !item.sub_header
                )"
              >
                <el-submenu
                  :index="item.moduleName"
                  class="custom"
                  v-if="item.children"
                  v-permission="Auth[item.authName]"
                >
                  <template slot="title">
                    <i class="os-icon" :class="item.icon"></i>
                    <span>{{ item.name }}{{ item.badge }}</span>
                  </template>
                  <el-menu-item
                    v-permission="Auth[item.authName]"
                    :index="child.moduleName"
                    :route="{ path: child.path }"
                    v-for="child in item.children"
                    :key="child.name"
                    >{{ child.name }}</el-menu-item
                  >
                </el-submenu>

                <el-menu-item
                  :index="item.moduleName"
                  :route="{ path: item.path }"
                  v-permission="Auth[item.authName]"
                  v-else
                >
                  <i class="os-icon" :class="item.icon"></i>
                  <span slot="title">{{ item.name }}</span>
                  <span
                    class="menu-badge"
                    v-if="item.badge && item.badge > 0"
                    >{{ item.badge }}</span
                  >
                </el-menu-item>
              </template>
            </template>
          </el-menu> -->
          <div>
            <div @mouseleave="switchMenuGroup('')">
              <el-menu
                class="el-menu-main"
                :class="selectedHoverClass"
                text-color="#F1F5FD"
                active-text-color="#F1F5FD"
                :unique-opened="true"
                :default-active="activeMainIndex"
                @select="handleMenuSelect"
                v-show="selectedMenu.children.length == 0 || selectedHoverClass"
              >
                <template v-for="(group, index) in menuGroups">
                  <el-menu-item
                    :index="'' + index"
                    v-permission="Auth[group.authName]"
                    v-show="
                      !(
                        selectedHoverClass &&
                        index.toString() == activeMainIndex
                      )
                    "
                  >
                    <i class="main-menu-icon os-icon" :class="group.icon"></i>
                    <span>{{ group.name }}</span>
                    <span
                      class="menu-badge"
                      v-if="group.badge && group.badge > 0"
                      >{{ group.badge }}</span
                    >
                  </el-menu-item>
                </template>
              </el-menu>
            </div>
            <div
              class="sub-menu-container"
              v-show="selectedMenu.children.length > 0"
            >
              <div
                class="sub-menu-title"
                :class="selectedHoverClass"
                @click="switchMobileMenuGroup()"
              >
                <div>
                  <i
                    class="main-menu-icon os-icon"
                    :class="selectedMenu.icon"
                  ></i>
                  <span>{{ selectedMenu.name }}</span>
                  <i class="os-icon os-icon-chevron-down ml-5"></i>
                </div>
              </div>
              <el-menu
                class="el-menu-vertical el-menu-sub"
                text-color="#3e4b5b"
                active-text-color="#047bf8"
                :router="true"
                :unique-opened="true"
                :default-active="$route.name"
              >
                <template v-for="(item, index) in selectedMenu.children">
                  <template v-if="item.sub_header">
                    <li class="sub-header" v-if="hasOneOfAuths(item.authNames)">
                      <span>{{ item.sub_header }}</span>
                    </li>
                  </template>
                  <template v-else>
                    <el-submenu
                      :index="item.moduleName"
                      v-permission="Auth[item.authName]"
                      class="custom"
                      v-if="item.children"
                    >
                      <template slot="title">
                        <i class="os-icon" :class="item.icon"></i>
                        <span>{{ item.name }}{{ item.badge }}</span>
                      </template>
                      <el-menu-item
                        :index="child.moduleName"
                        :route="{ path: child.path }"
                        v-for="child in item.children"
                        :key="child.name"
                        v-permission="Auth[item.authName]"
                        >{{ child.name }}</el-menu-item
                      >
                    </el-submenu>

                    <el-menu-item
                      :index="item.moduleName"
                      :route="{ path: item.path }"
                      :key="Math.random()"
                      v-show="item.name"
                      v-permission="Auth[item.authName]"
                      v-else
                    >
                      <i class="os-icon" :class="item.icon"></i>
                      <span slot="title">{{ item.name }}</span>
                      <span
                        class="menu-badge"
                        v-if="item.badge && item.badge > 0"
                        >{{ item.badge }}</span
                      >
                    </el-menu-item>
                  </template>
                </template>
              </el-menu>
            </div>
          </div>
        </div>
      </div>
      <div
        class="menu-w selected-menu-color-light menu-has-selected-link menu-activated-on-click color-scheme-light sub-menu-color-light menu-position-side menu-side-left menu-layout-compact sub-menu-style-inside"
      >
        <div @mouseleave="switchMenuGroup('')">
          <el-menu
            class="el-menu-main"
            :class="selectedHoverClass"
            text-color="#F1F5FD"
            active-text-color="#F1F5FD"
            :unique-opened="true"
            :default-active="activeMainIndex"
            @select="handleMenuSelect"
            v-show="selectedMenu.children.length == 0 || selectedHoverClass"
          >
            <template v-for="(group, index) in menuGroups">
              <el-menu-item
                :index="'' + index"
                v-permission="Auth[group.authName]"
                v-show="
                  !(selectedHoverClass && index.toString() == activeMainIndex)
                "
              >
                <i class="main-menu-icon os-icon" :class="group.icon"></i>
                <span>{{ group.name }}</span>
                <span
                  class="menu-badge"
                  v-if="group.badge && group.badge > 0"
                  >{{ group.badge }}</span
                >
              </el-menu-item>
            </template>
          </el-menu>
        </div>
        <div
          class="sub-menu-container"
          v-show="selectedMenu.children.length > 0"
        >
          <div
            class="sub-menu-title"
            :class="selectedHoverClass"
            @mouseenter="switchMenuGroup('hover')"
          >
            <div>
              <i class="main-menu-icon os-icon" :class="selectedMenu.icon"></i>
              <span>{{ selectedMenu.name }}</span>
              <i class="os-icon os-icon-chevron-down ml-5"></i>
            </div>
          </div>
          <el-menu
            class="el-menu-vertical el-menu-sub"
            text-color="#3e4b5b"
            active-text-color="#047bf8"
            :router="true"
            :unique-opened="true"
            :default-active="$route.name"
          >
            <template v-for="(item, index) in selectedMenu.children">
              <template v-if="item.sub_header">
                <li class="sub-header" v-if="hasOneOfAuths(item.authNames)">
                  <span>{{ item.sub_header }}</span>
                </li>
              </template>
              <template v-else>
                <el-submenu
                  :index="item.moduleName"
                  v-permission="Auth[item.authName]"
                  class="custom"
                  v-if="item.children"
                >
                  <template slot="title">
                    <i class="os-icon" :class="item.icon"></i>
                    <span>{{ item.name }}{{ item.badge }}</span>
                  </template>
                  <el-menu-item
                    :index="child.moduleName"
                    :route="{ path: child.path }"
                    v-for="child in item.children"
                    :key="child.name"
                    v-permission="Auth[item.authName]"
                    >{{ child.name }}</el-menu-item
                  >
                </el-submenu>

                <el-menu-item
                  :index="item.moduleName"
                  :route="{ path: item.path }"
                  :key="Math.random()"
                  v-show="item.name"
                  v-permission="Auth[item.authName]"
                  v-else
                >
                  <i class="os-icon" :class="item.icon"></i>
                  <span slot="title">{{ item.name }}</span>
                  <span
                    class="menu-badge"
                    v-if="item.badge && item.badge > 0"
                    >{{ item.badge }}</span
                  >
                </el-menu-item>
              </template>
            </template>
          </el-menu>
        </div>
      </div>
      <div class="content-w">
        <div class="content-i">
          <router-view
            @updateGoingCount="requestOngoingCount"
            :key="key"
          ></router-view>
          <footer class="footer">
            © {{ new Date().getFullYear() }} {{ app.name }}
          </footer>
        </div>
      </div>
      <user-set-dialog :show.sync="userSetDialogVisible"></user-set-dialog>
    </div>
  </div>
</template>

<script>
import userSetDialog from '@/components/user_set'
import store from '@/store/store'
import { app } from '@/config/env.js'

import { menuGroups } from '@/util/auth'
import {
  messageList,
  ongoinCount,
  search,
  serviceQuestRemind,
  userNoticeList,
  userLogout,
} from '../service/getData'
import { isMobile, formatTime } from '@/util/index'

import { hasAuth, hasOneOfAuths } from '@/permission'
import { messagesFormat, timePast } from '../util'

export default {
  components: {
    userSetDialog,
  },
  data() {
    return {
      app,
      hasAuth,
      timePast,
      hasOneOfAuths,
      mobileMenu: false,
      userSetDialogVisible: false,
      isMobile,
      menuGroups: [],
      selectedMenu: {
        name: '',
        icon: '',
        children: [],
      },
      messages: [],
      unreadMessageCount: 0,
      messageHover: false,
      selectedHoverClass: '',
      activeMainIndex: '0',
      timer: null,
      closing: false,
      searchLoading: false,
      selectQueryResult: null,
      searchResults: [],
      userNoticeCount: 0,
      key: 'vts',
    }
  },
  watch: {
    $route(to, from) {
      if (to.name == from.name) {
        this.key = `vts${to.params.id}`
      }
      this.selectedHoverClass = ''
      this.mobileMenu = false
      this.reloadMenu(to.name)
      this.loadBusinessData()

      this.selectQueryResult = null
      this.searchResults = []
    },
  },
  computed: {
    placeholder() {
      let arr = []

      if (hasAuth('customerList')) {
        arr.push('客户')
      }
      if (hasAuth('orderList')) {
        arr.push('报价单号')
      }
      // if (hasAuth('quotationList')) {
      //   arr.push('报价单号')
      // }

      let p = ''
      if (arr.length > 0) {
        p = '搜索' + arr.join('、')
      }

      return p
    },
    user() {
      return store.state.userInfo
    },
  },
  created() {
    var menus = []
    menuGroups.map((group) => {
      if (group.moduleName == 'customerManage') {
        group.children = group.children.filter(
          (item) =>
            !item.platform ||
            (item.platform == 1 && this.user.dealer_id == 0) ||
            (item.platform == 2 && this.user.dealer_id > 0),
        )
      }
      menus.push(group)
    })
    this.menuGroups = menus
    this.reloadMenu(this.$route.name)
    this.requestServiceQuestRemind()
    this.requestUnreadMessages()
    this.requestOngoingCount()

    if (window.$crisp) {
      $crisp.push(['set', 'user:nickname', [this.user.name]])
      $crisp.push(['set', 'user:phone', [this.user.phone_number]])
    }
  },
  mounted() {
    let that = this
    this.timer = setInterval(function () {
      that.requestUnreadMessages()
      that.loadBusinessData()
    }, 1000 * 60)
  },
  beforeDestroy() {
    if (this.user.dealer_id > 0) {
      clearInterval(this.timer)
    }
  },
  methods: {
    nagativeToUserNoticeList() {
      this.$router.push('/dashboard/user_notices')
    },
    nagativeToMessage() {
      this.$router.push('/dashboard/messages')
    },
    switchMobileMenu() {
      this.mobileMenu = !this.mobileMenu
    },
    async logout() {
      await userLogout()
      store.commit('logout')
      this.$router.push('/login')
    },
    reloadMenu(routeName) {
      for (let index = 0; index < this.menuGroups.length; index++) {
        const group = this.menuGroups[index]
        if (group.children.length == 0 && group.moduleName == routeName) {
          this.selectedMenu = {
            name: '',
            icon: '',
            children: [],
          }
          this.activeMainIndex = index.toString()
          return
        } else {
          let children = []
          group.children.map((item) => {
            children.push(item)

            if (item.children) {
              item.children.map((it) => {
                children.push(it)
              })
            }
          })
          for (let i = 0; i < children.length; i++) {
            const child = children[i]

            if (child.moduleName == routeName) {
              this.selectedMenu = group
              this.activeMainIndex = index.toString()
              return
            }
          }
        }

        this.selectedMenu = {
          name: '',
          icon: '',
          children: [],
        }
      }
    },
    handleMenuSelect(index) {
      this.selectedMenu = {
        name: '',
        icon: '',
        children: [],
      }
      this.activeMainIndex = '0'
      this.$nextTick(() => {
        let group = this.menuGroups[index]
        if (group.children.length > 0) {
          let paths = []
          group.children.map((item) => {
            if (item.children) {
              item.children.map((it) => {
                if (it.path) {
                  paths.push(it)
                }
              })
            } else {
              if (item.path) {
                paths.push(item)
              }
            }
          })

          for (let index = 0; index < paths.length; index++) {
            const item = paths[index]
            if (hasAuth(item.authName)) {
              this.$router.push(item.path)
              break
            }
          }
        } else {
          this.$router.push(group.path)
          this.activeMainIndex = '0'
        }
      })
    },

    switchMenuGroup(c = '') {
      // this.selectedHoverClass = this.selectedHoverClass == '' ? 'hover' : ''
      if (c == '' && this.activeMainIndex == '0') return
      this.selectedHoverClass = c
    },
    switchMobileMenuGroup() {
      this.selectedHoverClass = this.selectedHoverClass ? '' : 'hover'
    },
    // backHomeHandler() {
    //   this.$router.push('/dashboard')
    //   this.selectedMenu = null
    // },
    async search(query) {
      if (query !== '') {
        this.searchLoading = true
        let res = await search({
          query: query,
        })
        let searchResults = []
        if (res.code == 0) {
          let data = res.data
          if (data.customers && data.customers.length > 0) {
            searchResults.push({
              label: '客户',
              options: data.customers,
            })
          }

          if (data.orders && data.orders.length > 0) {
            searchResults.push({
              label: '报价单',
              options: data.orders,
            })
          }

          // if (data.quotations && data.quotations.length > 0) {
          //   searchResults.push({
          //     label: '报价单',
          //     options: data.quotations,
          //   })
          // }
        }
        this.searchResults = searchResults
        this.searchLoading = false
      } else {
        this.searchResults = []
      }
    },
    selectedQueryResult() {
      let type = this.selectQueryResult.type
      let id = this.selectQueryResult.id
      if (type == 1) {
        this.$router.push('/dashboard/dealer/orders/' + id)
      } else if (type == 2) {
        this.$router.push('/dashboard/quotations/' + id)
      } else if (type == 3) {
        this.$router.push('/dashboard/customers/' + id)
      }
    },
    async requestServiceQuestRemind() {
      let res = await serviceQuestRemind()
    },
    loadBusinessData(path) {
      // if (!path) {
      //   path = this.$route.path
      // }
      // if (
      //   path == '/dashboard/quotations' ||
      //   path == '/dashboard/dealer/orders' ||
      //   path == '/dashboard/dealer/purchase_orders' ||
      //   path == '/dashboard/user_notices' ||
      //   path == '/dashboard/customers' ||
      //   path == '/dashboard/shop/approve_orders' ||
      //   path == '/dashboard/shop/pending_orders'
      // ) {
      //   this.requestOngoingCount()
      // }
      this.requestOngoingCount()
    },
    async requestOngoingCount() {
      if (
        (this.user.dealer_id > 0 && this.selectedMenu.moduleName == 'sale') ||
        (this.user.dealer_id == 0 &&
          this.selectedMenu.moduleName == 'customerManage') ||
        this.selectedMenu.moduleName == 'product_promotion' ||
        this.selectedMenu.moduleName == 'serviceQuestManage' ||
        this.selectedMenu.moduleName == 'wiki' ||
        !this.selectedMenu.moduleName
      ) {
        let res = await ongoinCount()
        if (res.code == 0) {
          const ongoing = res.data
          this.menuGroups.map((group) => {
            if (
              group.moduleName == 'product_promotion' &&
              this.user.dealer_id == 0
            ) {
              group.badge = ongoing.commodity_approve_order
            }
            group.children.map((item) => {
              const moduleName = item.moduleName
              if (moduleName == 'order') {
                item.badge = ongoing.order
              } else if (moduleName == 'quotation') {
                item.badge = ongoing.quotation
              } else if (moduleName == 'purchase_order') {
                item.badge = ongoing.pruchase
              } else if (moduleName == 'customer_user_approve') {
                item.badge = ongoing.customer_user
              } else if (moduleName == 'commodity_approve_order') {
                item.badge = ongoing.commodity_approve_order
              } else if (moduleName == 'commodity_pending_order') {
                item.badge = ongoing.commodity_pending_order
              } else if (moduleName == 'cart') {
                item.badge = ongoing.cart
              } else if (moduleName == 'service_quests_new') {
                item.badge = ongoing.evaluate_service_quest
              } else if (moduleName == 'service_quests_ongoing') {
                item.badge = ongoing.running_service_quest
              } else if (moduleName == 'wiki_comment') {
                item.badge = ongoing.wiki_comment
              }
            })
          })
        }
      }
    },
    goback() {
      this.$router.go(-1)
    },
    async requestUnreadMessages() {
      let res = await messageList({ status: 1, limit: 5 })
      if (res.code == 0) {
        this.messages = messagesFormat(res.data.list)
        this.unreadMessageCount = res.data.total
      }
    },
    readMessage(index) {
      let msg = this.messages[index]
      if (msg.type == 8) {
        let others = this.messages.filter((i) => {
          return i.type != 8
        })
        this.messages = others
        this.unreadMessageCount = others.length
      } else {
        this.messages.splice(index, 1)
        this.unreadMessageCount -= 1
      }
    },
  },
}
</script>

<style>
.height-zero {
  height: 0 !important;
}
.message-list {
  width: 320px;
}
.top-bar .messages-notifications {
  color: #fff;
  margin-right: 25px;
}
.menu-w {
  background-color: transparent !important;
  position: relative;
}
.menu-w .logo-w {
  padding: 0 1rem 0 1.7rem;
  height: 55px;
}
.el-menu-main {
  background-color: #2167e8 !important;
  width: 220px;
  margin: 10px auto;
  box-shadow: 0 4px 6px #888888;
  padding: 10px !important;
}
.el-menu-main.hover {
  z-index: 10;
  padding-top: 54px !important;
}

.main-menu-icon {
  margin-right: 16px !important;
  color: #9ab9f5 !important;
  font-size: 16px;
  width: 18px;
}

.el-menu-main li.el-menu-item,
.sub-menu-title {
  height: 48px !important;
  letter-spacing: 0.5px;
  font-weight: 400;
  font-size: 14px;
  display: flex;
  align-items: center;
}

.el-menu-main li.el-menu-item.is-active {
  background-color: transparent !important;
}

.el-menu-main li.el-menu-item.is-active .el-icon-menu {
  color: #9ab9f5 !important;
}

.el-menu-main li.el-menu-item:hover {
  background-color: #047bf8 !important;
}

.el-menu-main li.el-menu-item:first-child {
  border-bottom: 0.5px solid #9ab9f5;
}

.el-menu-main.hover li.el-menu-item:first-child {
  border-bottom: none;
}

.el-menu-sub .el-menu-item,
.el-menu-sub .el-submenu__title {
  display: flex;
  align-items: center;
  height: 35px !important;
  line-height: 35px !important;
  padding-left: 15px;
}
.menu-and-user .el-menu-item,
.menu-and-user .el-submenu__title {
  height: 40px !important;
  line-height: 40px !important;
}

.menu-and-user .el-menu.el-menu--inline {
  padding: 0 !important;
}
.el-menu-sub {
  background: #fff !important;
  width: 252px;
  margin: 0 auto;
  box-shadow: 0 4px 6px #cccccc;
  padding: 30px 18px 18px !important;
}
.el-submenu__title {
  padding-left: 15px !important;
}

.sub-menu-container {
  position: absolute;
  top: 40px;
  left: 0;
  width: 100%;
}
.sub-menu-title {
  position: absolute;
  width: 220px;
  height: 48px;
  left: 50%;
  margin-left: -110px;
  top: -24px;
  background-color: #2167e8;
  color: #fff;
  z-index: 19;
  padding: 0 10px;
  display: flex;
  align-items: center;
  box-shadow: 0 4px 6px #cccccc;
  cursor: pointer;
}

.sub-menu-title div {
  width: 100%;
  height: 100%;
  align-items: center;
  display: flex;
  border-bottom: 0.5px solid #2167e8;
  padding-left: 15px;
  padding-right: 20px;
}
.sub-menu-title.hover div {
  border-bottom: 0.5px solid #9ab9f5;
}
.sub-menu-title.hover {
  box-shadow: none;
}

.sub-menu-title:hover {
  color: #fff;
}

.sub-menu-title .main-menu-icon {
  color: #fff !important;
}
.menu-and-user .el-submenu__title {
  color: #fff !important;
}
</style>

<style scoped>
.layout-col {
  display: flex;
  display: -webkit-box;
  display: -ms-flexbox;
  min-height: 100vh;
  flex-direction: column;
}
.top-bar {
  display: flex;
  display: -webkit-box;
  display: -ms-flexbox;
  /* background-color: #167ef5; */
  background: linear-gradient(to right, #fff, #167ef5);
  height: 51px;
  align-items: center;
  justify-content: space-between;
}

.logo {
  display: flex;
  align-items: bottom;
  width: 100%;
  justify-content: center;
}
.top-bar .logo-w {
  width: 280px;
  margin-left: 0;
  padding: 0;
}
.logo-label {
  font-size: 24px;
  margin-top: 2px;
}
.el-header {
  background: #ffffff;
  padding: 0;
  border-bottom: 1px solid #017fbe;
  box-shadow: 0 3px 5px #ccc;
}
.el-header .header {
  display: flex;
  height: 100%;
}
.el-header .header .logo {
  width: 240px;
  height: 100%;
  line-height: 60px;
  display: flex;
}

.el-header .header .logo a {
  display: inline-block;
  overflow: hidden;
}
.nav {
  height: 100%;
  line-height: 60px;
  padding: 0;
  margin: 0 auto;
}
.nav li {
  margin: 0;
  float: left;
  list-style: none;
  position: relative;
  cursor: pointer;
}
.nav li a {
  text-decoration: none;
  color: #fff;
  opacity: 0.55;
  padding: 0 16px;
  font-size: 14px;
}
.nav li a.router-link-active {
  opacity: 1;
}
.el-icon-message {
  color: #0087cb;
  font-size: 20px;
  margin-right: 12px;
  vertical-align: -2px;
}
.footer {
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 0;
  text-align: center;
  color: #888;
  height: 60px;
  line-height: 60px;
}
.sub-header {
  text-transform: uppercase;
  font-size: 0.72rem;
  letter-spacing: 1px;
  padding-top: 10px;
  padding-left: 15px;
  padding-bottom: 0;
  color: #909399;
  display: block;
}
.el-menu {
  padding: 1rem 20px;
  padding-top: 20px;
  margin-bottom: 0;
  border-right: none;
  background: #fff;
}
.sub-header span {
  display: block;
  padding: 6px 0;
  color: #448eef;
}
.el-menu-vertical i {
  display: inline-block;
  width: 40px;
  text-align: left;
  font-size: 18px;
  /* color: #448eef; */
}
.el-menu-item {
  display: flex;
  align-items: center;
  height: 35px;
  line-height: 35px;
  padding-left: 15px !important;
}
.el-menu-item.is-active {
  background: #2867e8;
  color: #fff !important;
}
.el-menu-item.is-active i,
.el-menu-item.is-active span {
  color: #fff !important;
}
.el-submenu .el-menu-item {
  padding-left: 80px !important;
  position: relative;
}
.el-submenu .el-menu-item::before {
  content: '';
  width: 5px;
  height: 5px;
  /* border: 1px solid ; */
  background: #909399;
  position: absolute;
  left: 60px;
  top: 50%;
  display: block;
  border-radius: 6px;
}
.el-submenu .el-menu-item.is-active::before {
  background: #fff;
}
.logged-user-info {
  display: flex;
  align-items: center;
}
.logged-user-info .name {
  margin-left: 8px;
  font-size: 12px;
}
.menu-badge {
  position: absolute;
  top: 50%;
  right: 20px;
  margin-top: -10px;
  font-size: 12px;
  height: 20px;
  background-color: #047bf8;
  color: #fff;
  padding: 0 4px;
  border-radius: 4px;
  line-height: 20px;
}
.log-img,
.log-img img {
  display: inline-block;
  height: 22px;
}

.top-menu-controls {
  height: 100%;
  padding: 0;
}
.dealer-name {
  text-align: left;
  line-height: 51px;
  /* color: #fff; */
  letter-spacing: 1px;
  font-weight: 400;
  display: flex;
  align-items: center;
}
.dealer-name span {
  margin-left: 5px;
}

.menu-and-user {
  background: #047bf8;
}

.menu-and-user .sub-menu-title {
  position: relative;
  top: 0px;
  width: 100%;
  margin-left: 0;
  left: 0;
  box-shadow: none;
  z-index: 99999;
}
.menu-and-user .sub-menu-container {
  top: 0;
  position: relative;
}
.menu-and-user .el-menu {
  margin-top: 0;
  width: 100%;
  z-index: 100;
  padding-top: 0 !important;
  padding-bottom: 20px !important;
}
.menu-and-user .el-menu-main {
  position: absolute;
  background: #2867e8 !important;
  z-index: 999;
  width: 100% !important;
  min-height: 100%;
  box-shadow: none;
}
.menu-and-user .el-menu-item {
  color: #fff !important;
}
.menu-and-user .sub-header span {
  color: #fff !important;
}
.message-more {
  text-align: center;
  margin-top: 10px;
  font-size: 12px;
  padding-top: 10px;
  border-top: 1px solid #eee;
}

.os-dropdown ul li a {
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  width: 100%;
}

.os-dropdown ul li a div:first-child {
  color: #333;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
}
.os-dropdown ul li a div:last-child {
  color: #888;
  width: 100px;
  font-size: 12px;
  text-align: right;
}
</style>
